import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Button from "../../../components/Button/Button";
import StyledSmText from "../../../common/components/styledSmText/StyledSmText";
import StyledLgText from "../../../common/components/styledLgText/StyledLgText";

const ContractSection = () => {
  const contractAddress = "Faf89929Ni9fbg4gmVZTca7eW6NFg877Jqn6MizT3Gvw";
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const textArea = document.createElement("textarea");
    textArea.value = contractAddress;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand("copy");
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Could not copy text: ", err);
    }

    document.body.removeChild(textArea);
  };

  return (
    <div className="relative flex justify-center w-full h-[85vh] sm:h-screen">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover -z-20"
      >
        <source src="/assets/animated-start.webm" type="video/webm" />
        Your browser does not support the video tag.
      </video>
      <div className="background-overlay absolute top-0 left-0 w-full h-full -z-10 opacity-50 bg-cover bg-center"></div>

      <div className="flex flex-col items-center justify-center gap-2 py-20 w-11/12 sm:w-fit relative z-10">
        {/* Jaba the Pepe */}
        <div className="self-end w-11/12 sm:w-fit">
          <img src="/assets/jaba-guard.svg" alt="Jaba the Pepe" />
        </div>

        {/* Contract Address */}
        <div className="flex justify-between items-center gap-5 bg-green/[0.40] border border-green rounded-md py-1.5 w-full sm:w-fit">
          <div className="w-[75%] sm:w-fit">
            <StyledLgText font="text-white break-words pl-5">
              {contractAddress}
            </StyledLgText>
          </div>

          {/* Copy Button */}
          <div className="relative flex flex-col items-center">
            {copied && (
              <StyledSmText font="absolute bottom-full mb-2 px-2 py-1 text-orange text-center">
                Text copied!
              </StyledSmText>
            )}
            <Button onClick={handleCopy} variant="" font="px-2 text-white">
              <Icon
                icon="fluent:document-copy-24-filled"
                width="36"
                height="36"
                className="text-white"
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractSection;
